import { toast } from 'react-toastify';
import axios from '../../axios';

import { GET_GROUP_IDS } from '../types';

export const getGroupIDs = () => async (dispatch) => {
  try {
    const res = await axios.get('/company/group/all');
    if (res.data.code === 1) {
      dispatch({
        type: GET_GROUP_IDS,
        payload: res.data.data,
      });
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
  }
};
